module.exports = __webpack_public_path__ + "assets/img/wk.68d12c7c.png";